const data = {
	"width": 24,
	"height": 24,
	"body": "<path fill=\"currentColor\" d=\"M14 19h4V5h-4M6 19h4V5H6v14Z\"/>"
};
exports.__esModule = true;
exports.default = data;
